const theme = {
  colors: {
    primary: '#F05A28',
    secondary: '#0E1330',
    accent: '#00ADEE',
    white: '#FFFFFF',
    lightGray: '#F5F5F5',
    gray: '#CCCCCC',
    darkGray: '#666666',
  },
  fonts: {
    main: "'Exo 2', sans-serif",
  },
  breakpoints: {
    mobile: '576px',
    tablet: '768px',
    laptop: '992px',
    desktop: '1200px',
  },
  transitions: {
    standard: '0.3s ease',
  },
  shadows: {
    small: '0 2px 4px rgba(0, 0, 0, 0.1)',
    medium: '0 4px 8px rgba(0, 0, 0, 0.1)',
    large: '0 8px 16px rgba(0, 0, 0, 0.1)',
  },
  spacing: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '2rem',
    xl: '3rem',
    xxl: '5rem',
  },
};

export default theme;
